import { render } from "./plagiarism.vue?vue&type=template&id=6bc9fa59&scoped=true"
import script from "./plagiarism.vue?vue&type=script&lang=js"
export * from "./plagiarism.vue?vue&type=script&lang=js"

import "./plagiarism.vue?vue&type=style&index=0&id=6bc9fa59&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc9fa59"]])

export default __exports__